const transformer = function (origin, defs, rowData, events, hooks) {
  const value = (origin || []).map((ori) => {
    return {
      ...ori,
      address: rowData.lnglat_text,
      createdAt: rowData.createdAt,
    }
  })

  return {
    render: 'media',
    value,
    origin,
    rowData,
    defs,
    events,
    hooks,
  }
}

export default transformer
